import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TeamManagementRoutingModule } from './team-management-routing.module';
import { TeamManagementComponent } from './team-management/team-management.component';
import { EmeraldCardModule } from '@emerald-angular/card';
import { EmeraldDesignSystemModule } from '@emerald-angular/design-system';
import { EmeraldInputModule } from '@emerald-angular/input';
import { AddExceptionComponent } from './add-exception/add-exception.component';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { TeamCompositionListComponent } from './team-composition-list/team-composition-list.component';
import { TeamManagementCardsComponent } from './team-management-cards/team-management-cards.component';
import { TeamManagementRowTwoComponent } from './team-management-row-two/team-management-row-two.component';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { RtoDetailsComponent } from './rto-details/rto-details.component';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { ChangeTeamComponent } from './change-team/change-team.component';
import { TeamCompositionDetailsComponent } from './team-composition-details/team-composition-details.component';
import { EmeraldAvatarModule } from '@emerald-angular/avatar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { SearchableSelectComponent } from '@app/pages/iskill/components/searchable-select/searchable-select.component';
import { Employee360Component } from '@app/pages/iskill/components/employee-360/employee-360.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgChartsModule } from 'ng2-charts';
import { ModalWrapperComponent } from '@app/shared/components/modal-wrapper/modal-wrapper.component';
import { VendorManagementModule } from '../vendor-management/vendor-management.module';
import { SharedModule } from '@shared/shared.module';
import { DateRangeComponent } from '@shared/components/date-range/date-range.component';
import { DropdownComponent } from '@app/shared/components/dropdown/dropdown.component';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { NewBeginningsComponent } from './new-beginnings/new-beginnings.component';
import { TeamManagementActionItemsComponent } from './team-management-action-items/team-management-action-items.component';
import { TeamTimesheetMetricsComponent } from './team-timesheet-metrics/team-timesheet-metrics.component';
import { TeamPerformanceSummaryComponent } from './team-performance-summary/team-performance-summary.component';
import { TeamPerformanceDetailsComponent } from './team-performance-details/team-performance-details.component';
import { ChartModule } from 'primeng/chart';

@NgModule({
  declarations: [
    TeamManagementComponent,
    AddExceptionComponent,
    TeamCompositionListComponent,
    TeamManagementCardsComponent,
    RtoDetailsComponent,
    TeamManagementRowTwoComponent,
    TeamCompositionDetailsComponent,
    ChangeTeamComponent,
    NewBeginningsComponent,
    TeamManagementActionItemsComponent,
    TeamTimesheetMetricsComponent,
    TeamPerformanceSummaryComponent,
    TeamPerformanceDetailsComponent,
  ],
  imports: [
    CommonModule,
    TeamManagementRoutingModule,
    EmeraldCardModule,
    EmeraldDesignSystemModule,
    EmeraldInputModule,
    EmeraldDropdownModule,
    EmeraldIconModule,
    EmeraldButtonModule,
    EmeraldAvatarModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    SearchableSelectComponent,
    Employee360Component,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    NgChartsModule,
    ChartModule,
    ModalWrapperComponent,
    VendorManagementModule,
    SharedModule,
    DateRangeComponent,
    DropdownComponent,
    ConfirmationDialogComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TeamManagementModule {}
